import { global } from "../constants";

export const data = {
    banner: {
        background: global.banner + "contact1.png",
        title: "",
        crumb: "Contact Us"
    }
}